<template>
  <div id="getOriginal" v-if="result">
    <div class="d1">
      根据当前文本内容进行原创检测，不可修改文本内容
    </div>
    <SearchInfo
      ref="searchinfo"
      :check="check"
      :percentage="percentage"
      :ptage="ptage"
      :contentCount="setNumber ? setNumber : contentCount"
      :contentTime="contentTime"
      checkType="original"
      @CheckOver="CheckOver"
    ></SearchInfo>
  </div>
  <div v-else>
    <div class="resultDiv">
      <p>{{ msg }}</p>
    </div>
    <div class="divmain countdiv">
      <span style="margin-right: 30px;"
        >检测字数：{{ setNumber ? setNumber : contentCount }}</span
      >
      <span>文章图片：{{ contentPic }}</span>
    </div>
    <div class="divmain countdiv">
      <span class="resultspan">查询结果：</span>
      <el-tag class="tagbtn" type="danger"
        >{{ getCount("serious") }}句严重重复</el-tag
      >
      <el-tag class="tagbtn" type="warning"
        >{{ getCount("secondary") }}句中等重复</el-tag
      >
      <el-tag class="tagbtn" type="success"
        >{{ getCount("low") }}句少量重复</el-tag
      >
    </div>
    <div class="divmain countdiv">
      <el-table
        :data="tableData"
        id="origTable"
        border
        style="width: 100%"
        :height="tabheight"
      >
        <el-table-column prop="content" label="查询语句" :width="310">
          <template slot-scope="scope">
            <div
              @click="checkSingular(scope.row.content, scope.row.originalValue)"
            >
              {{ scope.row.content }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="originalValue"
          align="center"
          label="百度文章相似度"
          :width="150"
        >
          <template slot-scope="scope">
            <div
              @click="goBaidu(scope.row.content)"
              :class="[
                scope.row.originalValue === 'serious'
                  ? 'ra'
                  : scope.row.originalValue === 'secondary'
                  ? 'rb'
                  : 'rc'
              ]"
            >
              {{
                scope.row.originalValue === "serious"
                  ? "严重重复"
                  : scope.row.originalValue === "secondary"
                  ? "中等重复"
                  : "少量重复"
              }}
              <img
                style="margin-left: 3px;vertical-align: -1px;"
                src="../../assets/image/icon_baidulogo.png"
              /><span style="color: blue">查百度</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="center divmain">
      <button class="btn3" @click="reset">重新检测</button>
    </div>
  </div>
</template>

<script>
import SearchInfo from "./SearchLoading";
import findWords from "../../assets/script/utils/findWords";
export default {
  name: "GetOriginal",
  components: {
    SearchInfo
  },
  computed: {
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      },
      set(val) {
        this.$store.state.contents.contentHeight = val;
      }
    },
    wycShow: {
      get() {
        return this.$store.state.contents.wycShow;
      },
      set(val) {
        this.$store.state.contents.wycShow = val;
      }
    },
    contentCount: {
      get() {
        return this.$store.state.editorControl.contentCount;
      }
    },
    contentPic: {
      get() {
        return this.$store.state.editorControl.contentPic;
      }
    },
    isOriginal: {
      get() {
        return this.$store.state.editorControl.isOriginal;
      },
      set(val) {
        return (this.$store.state.editorControl.isOriginal = val);
      }
    },
    sentence: {
      get() {
        return this.$store.state.editorControl.sentence;
      },
      set(val) {
        return (this.$store.state.editorControl.sentence = val);
      }
    }
  },
  data() {
    return {
      check: false,
      percentage: 0,
      ptage: null,
      result: true,
      contentTime: 10,
      getid: null,
      tabheight: 300,
      tableData: [],
      addList: [],
      pNumber: 0,
      setNumber: 0,
      msg:
        "本数据是从百度全网索引库查询而来，当发现该句在百度索引库中重复严重，将会以严重重复、中等重复、少量重复来标记，重复度越低的文章越容易被搜索引擎收录，所以请尽快利用智能原创进行调整，增加收录概率！"
    };
  },
  watch: {
    contentHeight: {
      handler: function(val) {
        this.getLineHeight(val);
      }
    },
    isOriginal: {
      handler(val) {
        if (val) {
          this.reset();
        }
      }
    },
    sentence: {
      handler(val) {
        if (val.length > 0) this.setNumber = val.length;
      }
    }
  },
  mounted() {
    if (this.isOriginal) {
      this.reset();
    }
    this.setNumber = this.sentence.length;

    this.getid = setInterval(() => {
      let getBox = document.getElementById("origTable");
      if (getBox) {
        clearInterval(this.getid);
        this.getLineHeight(this.contentHeight);
        this.isOriginal = false;
      }
    }, 500);
  },
  methods: {
    reset() {
      this.setNumber = 0;
      this.result = true;
      this.$nextTick(() => {
        this.$refs.searchinfo.checkin();
      });
    },
    clear() {
      this.check = false;
      this.percentage = 0;
      this.ptage = null;
      this.result = true;
    },
    CheckOver(getMsg) {
      if (getMsg.ErrorCode > 0) {
        if (getMsg.ErrorCode === 200501) {
          this.insertConfig.showUpgrade(true, "获取更多使用次数");
        } else {
          this.$message({
            showClose: true,
            message: getMsg.ErrorMess,
            type: "error"
          });
        }
        return;
      }

      this.tableData = [];
      this.addList = [];
      let i = 0;
      for (let list of getMsg.Data.Result) {
        for (let item of list) {
          this.tableData.push({
            content: item.Content,
            originalValue: item.OriginalValue,
            index: i
          });
        }
        ++i;
      }
      this.result = false;
      this.percentage = 0;
    },
    getCount(type) {
      let list = [];
      for (let item of this.tableData) {
        if (item.originalValue === type) {
          list.push(item.content);
        }
      }
      return list.length;
    },
    goBaidu(words) {
      window.open("https://www.baidu.com/s?wd=" + words);
    },
    getOriColor(type) {
      if (type === "serious") {
        return "ori1";
      }
      if (type === "secondary") {
        return "ori2";
      }
      if (type === "low") {
        return "ori3";
      }
    },
    checkSingular(words, type) {
      findWords.closeAllHighlight();
      findWords.findkeywords(words, this.getOriColor(type));
    },
    getLineHeight(windowheight) {
      let toolbar = document.querySelector(".el-header");

      let editorToolbarHeight = 0;
      if (toolbar !== null && toolbar !== undefined) {
        editorToolbarHeight = toolbar.offsetHeight;
      }

      let righttitle = document.querySelector(".tLeft");

      let righttitleHeight = 0;
      if (righttitle !== null && righttitle !== undefined) {
        righttitleHeight = righttitle.offsetHeight;
      }
      let editorStatusBarHeight = 250;
      let realHeight =
        windowheight -
        editorToolbarHeight -
        editorStatusBarHeight -
        righttitleHeight;
      this.tabheight = realHeight + "px";
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/mixin";
@import "../../assets/style/color";

/deep/.el-table__row {
  .cell {
    div {
      cursor: pointer;
      height: 100%;
      width: 100%;
    }
  }
}
/deep/.el-table__body-wrapper {
  overscroll-behavior-y: contain;
}

* {
  font-size: 12px;
}
.d1 {
  line-height: 30px;
  margin-top: 5px;
  padding: 0 15px;
}
.divmain {
  padding: 5px 10px;
  margin: 15px 10px;
}
.resultDiv {
  .divmain;
  border: 1px solid #f0ddb5;
  background-color: #fffaf4;
  p {
    color: #f6b12f;
  }
}
.countdiv {
  margin: 2px 0px 2px 0;
  padding: 5px 10px;
}

.btn {
  background-color: @button-color;
  padding: 3px 9px;
  color: #fff;
  border: 1px solid @button-color;
  border-radius: 10px;
  cursor: pointer;
  margin-right: 8px;
}
.btn3 {
  .btn;
  padding: 5px 15px;
  background-color: @button-color;
}
.tagbtn {
  padding: 2px 5px;
  border-radius: 10px;
  margin-right: 10px;
  display: initial;
}
.resultspan {
  font-size: 14px;
}

.ra {
  color: #f56c6c;
}
.rb {
  color: #e6a23c;
}
.rc {
  color: #67c23a;
}
</style>
